import { DomainException } from './domain-exception';

export class DataNotFoundException extends DomainException {
  constructor(message: string) {
    super(message);
  }
}
